<template>
  <b-sidebar :id="sidebarFields" sidebar-class="custom-sidebar-container sidebar-fields" ref="sidebar_fields" title="Настройка колонок" right shadow backdrop @hidden="onHidden">
    <div class="d-flex flex-column h-100">
      <div class="flex-grow-1 overflow-auto p-3">
        <div v-if="!configureRequired && (isDragging || fieldsLeft.length > 0)">
          <div class="font-weight-bold text-small text-muted mb-2 mt-1">ЗАКРЕПЛЕНЫ СЛЕВА</div>
          <draggable
            v-model="fieldsLeft"
            group="columns"
            handle=".drag-handle"
            class="drag-zone"
            :class="{ 'drop-placeholder-active': isDragging && fieldsLeft.length === 0 }"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <div v-for="field in fieldsLeft" :key="field.id" class="export-list-item mb-1">
              <div class="d-flex align-items-center text-truncate">
                <span class="drag-handle text-dark mr-2">
                  <v-icon name="buttons/dots" :size="12"/>
                </span>
                <span class="text-secondary mr-2 cursor-pointer" title="Открепить" @click="unpinField(field)">
                  <v-icon name="buttons/pin" :size="13"/>
                </span>
                <span class="text-small">{{ field.label }}</span>
                <span v-if="configureRequired && field.required && field.visible" class="text-danger font-weight-bold ml-2">*</span>
              </div>

              <div class="d-flex align-items-center" style="gap: 12px;">
                <b-form-checkbox
                  v-if="configureRequired"
                  v-model="field.required"
                  :disabled="!field.visible"
                  class="m-0"
                />

                <div class="ant-switch-wrapper" :class="{ 'is-disabled': visibleFields.length === 1 && field.visible }" @click="toggleField(field)">
                  <div class="pure-switch-track" :class="{ 'is-checked': field.visible }"/>
                  <div class="switch-icons-overlay">
                    <v-icon v-show="field.visible" name="buttons/check" :size="11" class="ml-2" style="color: #fff"/>
                    <span v-show="!field.visible" class="flex-grow-1"/>
                    <v-icon v-show="!field.visible" name="buttons/cross" :size="10" class="mr-2" style="color: #fff"/>
                  </div>
                  <div class="pure-switch-thumb" :class="{ 'is-checked': field.visible }"/>
                </div>

                <div v-if="allowDelete && !field.isSeparator" class="position-relative d-flex align-items-center ml-2">
                  <v-icon :id="'delete-btn-left-' + field.key" name="buttons/trash" :size="14" class="cursor-pointer"/>
                  <b-popover :target="'delete-btn-left-' + field.key" triggers="click blur" placement="left" container="sidebarFields">
                    <div class="text-small font-weight-bold mb-2">Удалить колонку?</div>
                    <div class="d-flex" style="gap: 8px;">
                      <b-btn class="custom-btn-primary btn-sm" @click.stop="onDeleteKanbanCol(field, 'left')">Да</b-btn>
                      <b-btn class="custom-btn-secondary btn-sm" @click.stop="$root.$emit('bv::hide::popover', 'delete-btn-left-' + field.key)">Нет</b-btn>
                    </div>
                  </b-popover>
                </div>
              </div>
            </div>
          </draggable>
        </div>

        <div v-if="!configureRequired" class="font-weight-bold text-small text-muted mb-2 mt-3">ТАБЛИЦА</div>
        <draggable
          v-model="fieldsCenter"
          group="columns"
          handle=".drag-handle"
          class="drag-zone"
          @start="isDragging = true"
          @end="isDragging = false"
        >
          <div v-for="field in fieldsCenter" :key="field.id" class="export-list-item mb-1">
            <div v-if="field.isSeparator" class="font-weight-bold text-small text-muted text-uppercase p-2 my-1 w-100">
              {{ field.label }}
            </div>
            <template v-else>
              <div class="d-flex align-items-center text-truncate">
                <span class="drag-handle text-dark mr-2">
                  <v-icon name="buttons/dots" :size="12"/>
                </span>
                <span v-if="!configureRequired" class="text-secondary mr-2">
                  <v-icon name="buttons/unpin" :size="13"/>
                </span>
                <span class="text-small">{{ field.label }}</span>
                <span v-if="configureRequired && field.required && field.visible" class="text-danger font-weight-bold ml-2">*</span>
              </div>

              <div class="d-flex align-items-center" style="gap: 12px;">
                <b-form-checkbox
                  v-if="configureRequired"
                  v-model="field.required"
                  :disabled="!field.visible"
                  class="m-0"
                />

                <div class="ant-switch-wrapper" :class="{ 'is-disabled': visibleFields.length === 1 && field.visible }" @click="toggleField(field)">
                  <div class="pure-switch-track" :class="{ 'is-checked': field.visible }"></div>
                  <div class="switch-icons-overlay">
                    <v-icon v-show="field.visible" name="buttons/check" :size="11" class="ml-2" style="color: #fff" />
                    <span v-show="!field.visible" class="flex-grow-1"></span>
                    <v-icon v-show="!field.visible" name="buttons/cross" :size="10" class="mr-2" style="color: #fff" />
                  </div>
                  <div class="pure-switch-thumb" :class="{ 'is-checked': field.visible }"></div>
                </div>

                <div v-if="allowDelete && !field.isSeparator" class="position-relative d-flex align-items-center ml-2">
                  <v-icon :id="'delete-btn-center-' + field.key" name="buttons/trash" :size="14" class="cursor-pointer"/>
                  <b-popover :target="'delete-btn-center-' + field.key" triggers="click blur" placement="left" container="sidebarFields">
                    <div class="text-small font-weight-bold mb-2">Удалить колонку?</div>
                    <div class="d-flex" style="gap: 8px;">
                      <b-btn class="custom-btn-primary btn-sm" @click.stop="onDeleteKanbanCol(field, 'center')">Да</b-btn>
                      <b-btn class="custom-btn-secondary btn-sm" @click.stop="$root.$emit('bv::hide::popover', 'delete-btn-center-' + field.key)">Нет</b-btn>
                    </div>
                  </b-popover>
                </div>
              </div>
            </template>
          </div>
        </draggable>

        <div v-if="!configureRequired && (isDragging || fieldsRight.length > 0)">
          <div class="font-weight-bold text-small text-muted mb-2 mt-3">ЗАКРЕПЛЕНЫ СПРАВА</div>
          <draggable
            v-model="fieldsRight"
            group="columns"
            handle=".drag-handle"
            class="drag-zone"
            :class="{ 'drop-placeholder-active': isDragging && fieldsRight.length === 0 }"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <div v-for="field in fieldsRight" :key="field.id" class="export-list-item mb-1">
              <div class="d-flex align-items-center text-truncate">
                <span class="drag-handle text-dark mr-2">
                  <v-icon name="buttons/dots" :size="12"/>
                </span>
                <span class="text-secondary mr-2 cursor-pointer" title="Открепить" @click="unpinField(field)">
                  <v-icon name="buttons/pin" :size="13"/>
                </span>
                <span class="text-small">{{ field.label }}</span>
                <span v-if="configureRequired && field.required && field.visible" class="text-danger font-weight-bold ml-2">*</span>
              </div>

              <div class="d-flex align-items-center" style="gap: 12px;">
                <b-form-checkbox
                  v-if="configureRequired"
                  v-model="field.required"
                  :disabled="!field.visible"
                  class="m-0"
                />

                <div class="ant-switch-wrapper" :class="{ 'is-disabled': visibleFields.length === 1 && field.visible }" @click="toggleField(field)">
                  <div class="pure-switch-track" :class="{ 'is-checked': field.visible }"></div>
                  <div class="switch-icons-overlay">
                    <v-icon v-show="field.visible" name="buttons/check" :size="11" class="ml-2" style="color: #fff"/>
                    <span v-show="!field.visible" class="flex-grow-1"></span>
                    <v-icon v-show="!field.visible" name="buttons/cross" :size="10" class="mr-2" style="color: #fff"/>
                  </div>
                  <div class="pure-switch-thumb" :class="{ 'is-checked': field.visible }"></div>
                </div>

                <div v-if="allowDelete && !field.isSeparator" class="position-relative d-flex align-items-center ml-2">
                  <v-icon :id="'delete-btn-right-' + field.key" name="buttons/trash" :size="14" class="cursor-pointer"/>
                  <b-popover :target="'delete-btn-right-' + field.key" triggers="click blur" placement="left" container="sidebarFields">
                    <div class="text-small font-weight-bold mb-2">Удалить колонку?</div>
                    <div class="d-flex" style="gap: 8px;">
                      <b-btn class="custom-btn-primary btn-sm" @click.stop="onDeleteKanbanCol(field, 'right')">Да</b-btn>
                      <b-btn class="custom-btn-secondary btn-sm" @click.stop="$root.$emit('bv::hide::popover', 'delete-btn-right-' + field.key)">Нет</b-btn>
                    </div>
                  </b-popover>
                </div>
              </div>
            </div>
          </draggable>
        </div>

        <div class="mt-3">
          <slot name="list-append"></slot>
        </div>
      </div>

      <div class="export-sidebar-footer px-3 py-3 border-top">
        <div class="d-flex flex-wrap align-items-center" style="gap: 12px;">
          <b-button v-if="!allowDelete" variant="link" class="text-small p-0" style="color: #F5222D !important; text-decoration: none !important;" @click="resetColumns">
            Сбросить
          </b-button>
          <b-button v-if="checkAll" class="text-small text-dark p-0" variant="link" style="text-decoration: none !important; color: #6c757d;" @click="checkAllColumns(false)">
            <v-icon name="buttons/toggle_left" :size="15" class="mr-1 pt-1"/>
            Снять все
          </b-button>
          <b-button v-else variant="link" class="text-small text-dark p-0" style="text-decoration: none !important" @click="checkAllColumns(true)">
            <v-icon name="buttons/toggle_right" :size="15" class="mr-1 pt-1"/>
            Выбрать все
          </b-button>
          <b-button class="custom-btn-primary ml-auto" @click="handleSave()">
            <v-icon name="buttons/save" :size="13" class="mr-1" />
            Сохранить
          </b-button>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: 'DynamicTables',
  components: { draggable },
  props: {
    storageKey: { type: String, required: true },
    sidebarFields: { type: String, required: true },
    fieldsModel: { type: Array, required: true },
    fieldKey: { type: String, required: true },
    configureRequired: { type: Boolean, default: false },
    allowDelete: { type: Boolean, default: false }
  },
  data() {
    return {
      fieldsLeft: [],
      fieldsCenter: [],
      fieldsRight: [],
      checkAll: true,
      isDragging: false,
    };
  },
  async created() {
    this.initColumns();
  },
  computed: {
    localFields() {
      const mark = (array, value) => array.map(f => ({ ...f, sticky: value }));
      return [
        ...mark(this.fieldsLeft, 'left'),
        ...mark(this.fieldsCenter, null),
        ...mark(this.fieldsRight, 'right')
      ];
    },
    visibleFields() {
      return this.localFields.filter(f => f.visible && !f.isSeparator);
    },
    lists() {
      return [this.fieldsLeft, this.fieldsCenter, this.fieldsRight];
    }
  },
  watch: {
    fieldsModel: {
      handler(newFields, oldFields) {
        const hasNewKeys = newFields.some(f => !oldFields.some(of => of.key === f.key));
        if (newFields.length !== oldFields.length || hasNewKeys) {
          this.initColumns();
        }
      }, deep: true
    },
    lists: {
      handler() {
        const payload = this.localFields.map(field => {
          if (this.configureRequired && !field.visible) field.required = false;
          return field;
        });
        this.$emit('update:fieldsModel', payload);
      }, deep: true
    }
  },
  methods: {
    initColumns() {
      const merged = this.mergeColumns(this.fieldsModel);

      if (this.configureRequired) {
        this.fieldsLeft = [];
        this.fieldsRight = [];
        this.fieldsCenter = merged;
      } else {
        this.fieldsLeft = merged.filter(f => f.sticky === 'left');
        this.fieldsRight = merged.filter(f => f.sticky === 'right');
        this.fieldsCenter = merged.filter(f => f.sticky !== 'left' && f.sticky !== 'right');
      }

      this.checkAll = merged.every(field => field.visible);
    },
    mergeColumns(incomingFields) {
      const storedFields = localStorage.getItem(this.storageKey);
      const storedSettings = storedFields ? JSON.parse(storedFields) : null;

      if (!storedSettings) return [...incomingFields];

      const mergedFields = storedSettings.map(storedField => {
        const baseField = incomingFields.find(f => f.key === storedField.key);
        if (baseField) {
          return {
            ...baseField,
            visible: storedField.visible,
            required: storedField.required !== undefined ? storedField.required : baseField.required,
            sticky: storedField.sticky
          };
        }
        return null;
      }).filter(Boolean);

      const storedKeys = new Set(mergedFields.map(f => f.key));
      const newFields = incomingFields.filter(f => !storedKeys.has(f.key)).map(f => ({ ...f, required: f.required || false }));

      return [...mergedFields, ...newFields];
    },
    unpinField(field) {
      ['fieldsLeft', 'fieldsRight'].forEach(listName => {
        const idx = this[listName].findIndex(f => f.key === field.key);
        if (idx !== -1) {
          const [removed] = this[listName].splice(idx, 1);
          this.fieldsCenter.unshift(removed);
        }
      });
    },
    onDeleteKanbanCol(field, zoneSuffix) {
      this.$root.$emit('bv::hide::popover', `delete-btn-${zoneSuffix}-${field.key}`);
      this.lists.forEach(list => {
        const index = list.findIndex(f => f.key === field.key);
        if (index !== -1) list.splice(index, 1);
      });
      this.saveColumns();
      this.$emit('delete-col', field);
    },
    toggleField(field) {
      if (this.visibleFields.length === 1 && field.visible) return;
      field.visible = !field.visible;
    },
    checkAllColumns(flag) {
      if (flag) {
        this.lists.forEach(list => list.forEach(item => { if (!item.isSeparator) item.visible = true; }));
      } else {
        let keptOne = false;
        this.lists.forEach(list => list.forEach(item => {
          if (item.isSeparator) return;
          if (!keptOne) { item.visible = true; keptOne = true; }
          else { item.visible = false; }
        }));
      }
      this.checkAll = flag;
    },
    handleSave() {
      this.saveColumns();
      this.$refs.sidebar_fields.hide();
    },
    saveColumns() {
      localStorage.setItem(this.storageKey, JSON.stringify(this.localFields));
      this.$bvToast.toast("Успешное сохранение колонок.", {
        title: 'Сохранено',
        variant: 'success',
        autoHideDelay: 3000,
        solid: true
      });
    },
    async resetColumns() {
      this.$refs.sidebar_fields.hide();
      const isConfirmed = await this.$bvModal.msgBoxConfirm('Вы хотите вернуть стандартные настройки? (Это также обновит текущую страницу).', {
        title: 'Сброс настроек',
        size: 'md',
        buttonSize: 'sm',
        headerBgVariant: 'danger',
        okVariant: 'danger',
        okTitle: 'Сбросить',
        cancelTitle: 'Отмена',
        footerClass: 'p-1',
        centered: true
      });

      if (!isConfirmed) return;

      localStorage.removeItem(this.storageKey);
      this.initColumns();

      this.$bvToast.toast("Настройки таблицы сброшены.", {
        title: 'Успешно',
        variant: 'warning',
        autoHideDelay: 2000,
        solid: true
      });
      setTimeout(() => {
        location.reload();
      }, 1111);
    },
    onHidden() {
      this.$emit('sidebar-closed');
    },
  },
}
</script>

<style>
.drag-handle {
  cursor: grab;
}

.sidebar-fields {
  z-index: 1060 !important;
}

.drag-zone {
  min-height: 10px;
  transition: background-color 0.2s, border 0.2s;
  border-radius: 6px;
  position: relative;
}

.drag-zone:hover.drop-placeholder-active {
  border-color: #1A9167 !important;
  background-color: #E6F7FF;
}

.drop-placeholder-active {
  min-height: 37px;
  border: 2px dashed #D9D9D9 !important;
  background-color: #FAFAFA;
}

.drop-placeholder-active::after {
  content: "Перетащите сюда";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #BFBFBF;
  font-size: 12px;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/DynamicTables.vue